document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.product__view-button');
  const details = document.querySelector('.product__view-details');
  const descriptionWrapper = document.querySelector('.product__description-wrapper');

  if (button && details && descriptionWrapper) {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const wasActive = button.classList.contains('is-active');

      details.classList.toggle('is-open');
      button.classList.toggle('is-active');

      if (wasActive) {
        descriptionWrapper.scrollIntoView({
          behavior: 'instant',
          block: 'start'
        });
      }
    });
  }
});
